// extracted by mini-css-extract-plugin
export var select = "_qu-0";